
import { useState, useCallback } from "react";
import { toast } from "sonner";
import { Investor } from "@/types/investor";
import { useInvestorAI } from "@/hooks/useInvestorAI";

/**
 * Hook for handling relevance submission operations
 */
export const useRelevanceOperations = (
  investors: Investor[],
  setInvestors: (investors: Investor[]) => void,
  processedIds: Set<string>,
  setProcessedIds: (processedIds: Set<string>) => void,
  contacts: any[] // Using any[] to avoid circular dependencies, but this is the Contact[] type
) => {
  const {
    isAnalyzing,
    handleRelevanceSubmit: aiHandleRelevanceSubmit,
  } = useInvestorAI();

  /**
   * Handle relevance submission
   */
  const handleRelevanceSubmit = useCallback(async (context: string) => {
    // Store the context in localStorage
    localStorage.setItem("relevance_context", context);
    
    return aiHandleRelevanceSubmit(
      context,
      investors,
      processedIds,
      (updatedInvestors) => {
        setInvestors(updatedInvestors);
        // This will be handled by the parent component's saveDataToSupabaseAndLocal
      },
      setProcessedIds
    );
  }, [investors, processedIds, setInvestors, setProcessedIds, aiHandleRelevanceSubmit]);

  return {
    isAnalyzing,
    handleRelevanceSubmit
  };
};
